<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter Acknowledgments" id="rw-frontmatter-Acknowledgments_70540-057174972"><div class="title-block" id="rw-title-block_70540-354412824"><h1 id="rw-h1_70540-347364843"><span href="#/9781455522866_tableofcontents" title="Link target outside of Sample">Acknowledgments</span></h1></div><p class="firstpara" id="rw-p_70540-125576150">Michele, I’ve said it before, but it bears repeating. Your insights are absolutely brilliant and make an incredible difference in my books. Thank you for everything.</p><p id="rw-p_70540-351012398">Lucienne, thank you so much for all of your advice, for answering questions, and most of all for your enthusiasm. I’m so fortunate to have you for an agent.</p><p id="rw-p_70540-856077249">Many thanks once again to Kati for being the best personal assistant ever. Thank you so very much!</p><p id="rw-p_70540-670354779">Also, lots of thanks and hugs to my street team partner Kieran Kramer and to all of the Regency Rockstars. You are all fabulous. xoxoxo</p><p id="rw-p_70540-988890703">To all of the readers, thank you so much for reading my books and for the kind e-mails letting me know how much you enjoy the stories I create. I wish you all hours of happy reading.</p><div class="block" id="rw-block-letter_70540-401714291"><p class="signature-fm" id="rw-signature_70540-181446685">Cheers!</p><p class="signature-continued-fm" id="rw-signature_70540-436492982">Vicky</p></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781455522866_acknowledgments.vue?288790e9